// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

type MenuItemBadgeProps = {
    badgeText?: string;
    extendedStyles?: MenuItemBadgeStyles;
};

export interface MenuItemBadgeStyles {
    wrapper?: InjectableCss;
    textBadge?: TypographyPresentationProps;
}

export const menuItemBadgeStyles: MenuItemBadgeStyles = {};

const MenuItemBadge: React.FC<MenuItemBadgeProps> = ({ badgeText, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(menuItemBadgeStyles, extendedStyles));

    if (!badgeText) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.textBadge}>{badgeText}</Typography>
        </StyledWrapper>
    );
};

export default MenuItemBadge;
